// Text wordmark that echoes the CIFF visual identity — a magenta bar at left
// next to the platform name. The actual CIFF logo is intentionally NOT used.
import React from "react";

export function Wordmark() {
    return (
        <div className="flex items-stretch gap-3 leading-none">
            {/* Magenta vertical bar — visual echo of CIFF's left-block treatment */}
            <div className="w-[6px] flex-shrink-0 bg-ciff-magenta" />
            <div className="flex flex-col justify-center leading-tight py-0.5">
                <span className="font-heading text-[17px] font-bold text-ciff-ink tracking-tight">
                    Due Diligence
                </span>
                <span className="text-[9px] uppercase tracking-[0.22em] text-ciff-inkSoft font-mono mt-0.5">
                    NGO Screening Platform
                </span>
            </div>
        </div>
    );
}
